module.exports = __webpack_public_path__ + "static/media/Arrow.35ef1e11.png";